import { render } from "./BaseButtonTop.vue?vue&type=template&id=04d1d567&scoped=true&lang=pug"
import script from "./BaseButtonTop.vue?vue&type=script&lang=js"
export * from "./BaseButtonTop.vue?vue&type=script&lang=js"

import "./BaseButtonTop.vue?vue&type=style&index=0&id=04d1d567&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d1d567"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
